/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC, useMemo, useState } from "react";
import X2yBasic, { X2yBasicProps } from "./X2yBasic";
import { OptionData } from "../../OptionList/types";
import { OptionListData } from "../types";
import { useMultiAutofetchEffect } from "./useReduxHoox";

export type Props = Pick<
  X2yBasicProps,
  "controller" | "onSaveCallback" | "disableSearch" | "listSize"
> & {
  multiListOptions: OptionData[];
  multiListHeader?: string;
};

const X2yMulti: FC<Props> = ({
  multiListHeader,
  multiListOptions,
  ...rest
}) => {
  const { controller, disableSearch, listSize = 10 } = rest;

  useMultiAutofetchEffect(controller, multiListOptions);

  const initialState = new Set<string>();
  const [activeIds, setActiveIds] = useState(initialState);

  const multiList: OptionListData = {
    options: multiListOptions,
    activeOptions: activeIds,
    onChangeOfActiveOptions: setActiveIds,
    searchEnabled: !disableSearch,
    header: multiListHeader,
    size: listSize,
  };

  const xIds = useMemo(() => [...activeIds].map(Number), [activeIds]);

  return <X2yBasic {...rest} xIdOrIds={xIds} multiList={multiList} />;
};

export default X2yMulti;
export type X2yMultiProps = Props;
